import styled from 'styled-components';

export const ImageContainer = styled.div`
  margin: 12px 0 12px 20px;
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Image = styled.img`
  max-width: 100%;
  max-height: 100%;
`;
